import { type RouteRecordRaw } from "vue-router";
import { ROUTE_NAME } from "@/shared/constants/routes";

export const routes: RouteRecordRaw[] = [
  {
    path: "/website",
    name: ROUTE_NAME.WEBSITE,
    component: () => import("./views/WebsiteView.vue"),
  },
];
